(function () {
  var STORAGE_KEY = 'nataal_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }
    saveWishlist(list);
    updateWishlistBadge();
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { handle: handle, list: list } }));
    return list.indexOf(handle) !== -1;
  }

  function updateWishlistBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function syncButtonState(btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    btn.classList.toggle('is-active', isInWishlist(handle));
  }

  function initButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      syncButtonState(btn);
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.getAttribute('data-product-handle');
        if (!handle) return;
        var nowActive = toggleWishlist(handle);
        btn.classList.toggle('is-active', nowActive);
        document.querySelectorAll('[data-wishlist-toggle][data-product-handle="' + handle + '"]').forEach(function (other) {
          other.classList.toggle('is-active', nowActive);
        });
      });
    });
  }

  function renderWishlistPage() {
    var container = document.querySelector('[data-wishlist-grid]');
    var emptyState = document.querySelector('[data-wishlist-empty]');
    if (!container) return;

    var handles = getWishlist();

    if (handles.length === 0) {
      container.style.display = 'none';
      if (emptyState) emptyState.style.display = 'block';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';
    container.style.display = '';
    container.innerHTML = '';

    var fetches = handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (products) {
      products.forEach(function (product, i) {
        if (!product) return;
        container.appendChild(buildCard(product, handles[i]));
      });
      initButtons(container);
      if (container.children.length === 0) {
        container.style.display = 'none';
        if (emptyState) emptyState.style.display = 'block';
      }
    });
  }

  function buildCard(product, handle) {
    var card = document.createElement('div');
    card.className = 'product-card';

    var priceLabel = product.variants.length > 1 && hasVaryingPrice(product)
      ? 'D\u00e8s ' + formatMoney(getMinPrice(product))
      : formatMoney(product.price);

    var img = product.featured_image ? product.featured_image : (product.images[0] || '');

    card.innerHTML =
      '<a href="/products/' + product.handle + '" class="product-card-link">' +
        '<div class="product-card-media">' +
          (img ? '<img src="' + img + '&width=600" alt="' + escapeHtml(product.title) + '" loading="lazy" class="product-card-img product-card-img-primary">' : '<div class="product-card-placeholder"></div>') +
          '<button class="wishlist-btn is-active" data-wishlist-toggle data-product-handle="' + handle + '" aria-label="Retirer des favoris">' +
            '<svg viewBox="0 0 24 24" fill="none"><path d="M12 20.5s-7.5-4.6-10-9.3C.4 8 1.8 4.5 5 3.4c2.2-.8 4.5 0 6 2 1.5-2 3.8-2.8 6-2 3.2 1.1 4.6 4.6 3 7.8-2.5 4.7-10 9.3-10 9.3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="product-card-info">' +
          (product.type ? '<span class="product-card-collection">' + escapeHtml(product.type) + '</span>' : '') +
          '<h3 class="product-card-name">' + escapeHtml(product.title) + '</h3>' +
          '<div class="product-card-footer"><span class="product-card-price">' + priceLabel + '</span></div>' +
        '</div>' +
      '</a>';

    return card;
  }

  function hasVaryingPrice(product) {
    var prices = product.variants.map(function (v) { return v.price; });
    return Math.min.apply(null, prices) !== Math.max.apply(null, prices);
  }

  function getMinPrice(product) {
    return Math.min.apply(null, product.variants.map(function (v) { return v.price; }));
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR' });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    updateWishlistBadge();
    renderWishlistPage();
  });

  document.addEventListener('wishlist:changed', function () {
    if (document.querySelector('[data-wishlist-grid]')) {
      renderWishlistPage();
    }
  });

  window.NataalWishlist = {
    getWishlist: getWishlist,
    toggleWishlist: toggleWishlist,
    isInWishlist: isInWishlist,
    initButtons: initButtons
  };
})();
